import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const IncidentManagementAnalytics = ({ data, summaryMetrics }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-semibold text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-xs text-muted-foreground">
              <span style={{ color: entry?.fill }}>{entry?.name}: </span>
              <span className="font-medium">{entry?.value}</span>
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {summaryMetrics?.map((metric, index) => (
          <div 
            key={index}
            className="bg-muted/30 border border-border rounded-lg p-4"
          >
            <div className="flex items-center gap-2 mb-2">
              <Icon name={metric?.icon} size={16} color={metric?.color} />
              <p className="text-xs text-muted-foreground">{metric?.label}</p>
            </div>
            <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
            {metric?.subtext && (
              <p className="text-xs text-muted-foreground mt-1">{metric?.subtext}</p>
            )}
          </div>
        ))}
      </div>

      <div>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="category" 
              stroke="var(--color-muted-foreground)" 
              tick={{ fill: 'var(--color-muted-foreground)' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)" 
              tick={{ fill: 'var(--color-muted-foreground)' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ 
                paddingTop: '20px',
                color: 'var(--color-foreground)'
              }}
            />
            <Bar dataKey="reported" fill="var(--color-primary)" name="Reported" radius={[8, 8, 0, 0]} />
            <Bar dataKey="investigating" fill="var(--color-warning)" name="Investigating" radius={[8, 8, 0, 0]} />
            <Bar dataKey="closed" fill="var(--color-success)" name="Closed" radius={[8, 8, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default IncidentManagementAnalytics;